<script>

import NewNode from '@/components/workflows/nodes/NewNode';
import EmptyNode from '@/components/workflows/nodes/EmptyNode';
import ActionNode from '@/components/workflows/nodes/ActionNode';
import AssignNode from '@/components/workflows/nodes/AssignNode';
import ConditionBranchNode from '@/components/workflows/nodes/ConditionBranchNode';
import TriggerNode from '@/components/workflows/nodes/TriggerNode';
import ConditionNode from '@/components/workflows/nodes/ConditionNode';
import {useFocus} from '@/helpers/focus-effect';

export default {
  name: 'WorkflowEditorCanvas',
  template: '#workflow-editor-canvas-template',
  props: {
    workflow: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    return useFocus(true);
  },
  components: {
    NewNode,
    ActionNode,
    AssignNode,
    ConditionNode,
    ConditionBranchNode,
    TriggerNode,
    EmptyNode,
  },
};
</script>
